module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 03.c5d44178.svg";